import React from 'react';

const TodoCardsSkeleton = () => {
  const NUMBER_OF_CARD_SKELETONS = 12;

  return (
    <div className="bg-gray-100 shadow-toggleable-container">
      <div
        role="status"
        className="flex items-start  animate-pulse flex-col pt-10 pl-7 h-[236px] mobile:h-[258px] desktop:pr-4 mobile:pl-9 desktop:justify-between"
      >
        <div className="w-full">
          <div className="mb-3.5 h-[23px] w-[397px] rounded-full bg-gray-200" />
        </div>
        <div className="flex gap-4 overflow-hidden mb-0.8">
          {Array(NUMBER_OF_CARD_SKELETONS)
            .fill(true)
            .map((_, index) => (
              <div
                className="h-[150px] w-[210px] rounded-lg bg-gray-200"
                key={`card-skeleton-${index}`}
              />
            ))}
        </div>
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
};

export default TodoCardsSkeleton;
